import { Component } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { Form } from './../../models/forms/forms.model';

import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-forms-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html',
})
export class FormsListComponent extends ListBase<Form> {

  public url = 'forms';

  constructor(
    _communicationService: CommunicationService,
    _apiService: ApiService
  ) {
    super(
      _apiService,
      _communicationService
    )
  }

}
